/**
 * Identity for append-merge across scans (Romania vs GLOBAL, location refinements, rescans).
 * Excludes scope/country so toggling region keeps the same merge thread for one target.
 */

export function getStreamMergeIdentity(activeTab, tabStorage) {
  if (!tabStorage || typeof activeTab !== 'string') return '';
  switch (activeTab) {
    case 'company': {
      const name = String(tabStorage.company?.name || '').trim().toLowerCase();
      const domain = String(tabStorage.company?.domain || '').trim().toLowerCase();
      if (!name) return '';
      return `${name}|${domain}`;
    }
    case 'person': {
      return String(tabStorage.person?.input || '').trim().toLowerCase();
    }
    case 'email': {
      return String(tabStorage.email?.input || '').trim().toLowerCase();
    }
    case 'phone': {
      const raw = String(tabStorage.phone?.input || '').trim();
      const allTokenRe = /(?:^|:)\s*all\s*(?:$|:)/i;
      const normalizedPhone = raw.replace(allTokenRe, '').trim().replace(/^:+|:+$/g, '').trim();
      const digits = normalizedPhone.replace(/\D/g, '');
      return digits || normalizedPhone.toLowerCase();
    }
    default:
      return '';
  }
}

/** Short label for the merge banner log (current scope / country + optional location tags). */
export function buildAppendMergeLabel(activeTab, tabStorage) {
  if (!tabStorage || typeof activeTab !== 'string') return '';
  if (activeTab === 'company') {
    const parts = [];
    parts.push(tabStorage.company?.country === 'RO' ? 'Romania' : 'GLOBAL');
    if (tabStorage.company?.locationTags?.length) {
      parts.push(tabStorage.company.locationTags.join(', '));
    }
    return parts.join(' · ');
  }
  if (activeTab === 'person') {
    const scopeLabel = tabStorage.person?.searchScope === 'global' ? 'GLOBAL' : 'Romania';
    if (tabStorage.person?.locationTags?.length) {
      return `${scopeLabel} · ${tabStorage.person.locationTags.join(', ')}`;
    }
    return scopeLabel;
  }
  if (activeTab === 'phone') {
    return tabStorage.phone?.searchScope === 'global' ? 'GLOBAL' : 'Romania';
  }
  if (activeTab === 'email') {
    return 'email rescan';
  }
  return '';
}
